import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';

const setSearch = createAction(actionType.SET_SEARCH);
const resetSearch = createAction(actionType.RESET_SEARCH);
const clearSearch = createAction(actionType.CLEAR_SEARCH);

export { setSearch, resetSearch, clearSearch };
